import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dropShipApis } from "../utils/apis";
import { createAxiosInstanceOrder } from "../utils/request";

export const listAllDropShip = createAsyncThunk(
  "listAllDropShip",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(dropShipApis.getAllDropShip);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const listDropShipById = createAsyncThunk(
  "listDropShipById",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${dropShipApis.getDropShipById}?${payload.prequote_id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createDropShip = createAsyncThunk(
  "createDropShip",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        dropShipApis.createDropShip,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateDropShip = createAsyncThunk(
  "updateDropShip",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        dropShipApis.updateDropShip,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateDropShipStatus = createAsyncThunk(
  "updateDropShipStatus",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        dropShipApis.updateStatusDropShip,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getApprovedQtyShipDirect = createAsyncThunk(
  "getApprovedQtyPQC",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${dropShipApis.getApprovedQtyDropShip}?id=${payload?.id}`,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const ShipDirectSlice = createSlice({
  name: "Quote",
  initialState: {
    prequote: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(createDropShip.pending, (state) => {
        state.loading = true;
      })
      .addCase(createDropShip.fulfilled, (state, action) => {
        state.loading = false;
        state.quote = action.payload;
      })
      .addCase(createDropShip.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default ShipDirectSlice.reducer;
